/**
 * Tipos de erros conhecidos.
 */

export const EXPIRED_SESSION_ERROR = 'EXPIRED_SESSION_ERROR'
export const EXPIRED_APP_VERSION_ERROR = 'EXPIRED_APP_VERSION_ERROR'